import loanFormModel from '../../components/loan_application/form_models/loanFormModel';
import { ValidationSchema } from '../interfaces';
import { Validation } from '../Validation';
import CommunitySolarFinancialProjectionsRuleset from '../../pages/dashboard/loan_detail/flows/NewWelcomeFlow/business/ruleset/CommunitySolarFinancialProjectionsRuleset';
import { RulesetResult } from '../../pages/dashboard/loan_detail/flows/NewWelcomeFlow/business/rules';
import MultipleFilesValidationSchema from '../MultipleFilesValidationSchema';

const { communitySolarFinancialProjections } =
  loanFormModel.formField.solarSystemDocuments;

export class CommunitySolarFinancialProjectionsValidation
  implements ValidationSchema
{
  public name = communitySolarFinancialProjections.name;
  public label = '';

  public type = 'array';
  public required = {
    message: '',
    value: false,
  };
  public nullable = true;
  public min = {
    message: '',
    value: 1,
  };

  public ruleset = CommunitySolarFinancialProjectionsRuleset;

  public when(schema: any, ...args: any[]) {
    const result: RulesetResult = args.pop();
    const required = !!(result & RulesetResult.REQUIRED);
    const minFiles = this.min.value;

    return MultipleFilesValidationSchema(
      communitySolarFinancialProjections.name,
      required,
      minFiles
    );
  }
}
export default new Validation(
  new CommunitySolarFinancialProjectionsValidation()
);
